/**
 * Course Grid — search and load-more interactions.
 *
 * Uses event delegation so multiple blocks on the same page work independently.
 */

const DEBOUNCE_MS = 300;

function debounce( fn, delay ) {
    let timer;
    return ( ...args ) => {
        clearTimeout( timer );
        timer = setTimeout( () => fn( ...args ), delay );
    };
}

function getAjaxUrl() {
    return window.ohpAjax?.ajaxurl || '/wp-admin/admin-ajax.php';
}

/**
 * Append raw HTML <li> nodes to a grid and trigger UIkit layout update.
 */
function appendCards( grid, html ) {
    const tmp = document.createElement( 'ul' );
    tmp.innerHTML = html;
    [ ...tmp.children ].forEach( li => grid.appendChild( li ) );
    if ( window.UIkit ) UIkit.update( grid );
}

/**
 * Replace grid contents with raw HTML <li> nodes.
 */
function replaceCards( grid, html ) {
    grid.innerHTML = html || '<li class="uk-width-1-1 uk-text-center"><p class="uk-text-muted">No courses found.</p></li>';
    if ( window.UIkit ) UIkit.update( grid );
}

// ── Load More ─────────────────────────────────────────────────────────────────

document.addEventListener( 'click', async ( e ) => {
    const btn = e.target.closest( '.course-grid__load-more' );
    if ( ! btn ) return;

    const gridId  = btn.dataset.grid;
    const wrapId  = btn.dataset.wrap;
    const grid    = document.getElementById( gridId );
    const wrap    = document.getElementById( wrapId );
    if ( ! grid ) return;

    const page    = parseInt( btn.dataset.page, 10 );
    const perPage = btn.dataset.perPage || 9;
    const cat     = btn.dataset.category || '';
    const picked  = btn.dataset.picked || '';
    const nonce   = btn.dataset.nonce;

    btn.disabled = true;
    btn.textContent = 'Loading…';

    const body = new FormData();
    body.append( 'action',   'ohp_load_more_courses' );
    body.append( 'nonce',    nonce );
    body.append( 'page',     page );
    body.append( 'per_page', perPage );
    body.append( 'category', cat );
    body.append( 'picked',   picked );

    try {
        const res  = await fetch( getAjaxUrl(), { method: 'POST', body } );
        const data = await res.json();

        if ( data.success ) {
            appendCards( grid, data.data.html );

            if ( data.data.has_more ) {
                btn.dataset.page = page + 1;
                btn.disabled     = false;
                btn.textContent  = 'View More';
            } else {
                wrap?.remove();
            }
        }
    } catch ( err ) {
        btn.disabled    = false;
        btn.textContent = 'View More';
    }
} );

// ── Search ────────────────────────────────────────────────────────────────────

function initCourseSearch() {
    document.querySelectorAll( '.course-grid__search .uk-search-input' ).forEach( input => {
        input.addEventListener( 'input', debounce( async () => {
            const gridId  = input.dataset.grid;
            const wrapId  = input.dataset.wrap;
            const grid    = document.getElementById( gridId );
            const wrap    = document.getElementById( wrapId );
            if ( ! grid ) return;

            const keyword = input.value.trim();
            const perPage = input.dataset.perPage || 9;
            const cat     = input.dataset.category || '';
            const picked  = input.dataset.picked || '';
            const nonce   = input.dataset.nonce;

            // If cleared, restore load-more wrap
            if ( ! keyword && wrap ) wrap.style.display = '';

            const body = new FormData();
            body.append( 'action',   'ohp_search_courses' );
            body.append( 'nonce',    nonce );
            body.append( 'keyword',  keyword );
            body.append( 'per_page', perPage );
            body.append( 'category', cat );
            body.append( 'picked',   picked );

            try {
                const res  = await fetch( getAjaxUrl(), { method: 'POST', body } );
                const data = await res.json();

                if ( data.success ) {
                    replaceCards( grid, data.data.html );
                    // Hide load-more while searching (results are not paginated)
                    if ( wrap ) wrap.style.display = keyword ? 'none' : '';
                }
            } catch ( err ) {
                // Silent — grid keeps current state
            }
        }, DEBOUNCE_MS ) );
    } );
}

export default function initCourseGrid() {
    initCourseSearch();
}
